import { useState, useContext, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';
import {UserContext} from "../../App"

import { TextField, Autocomplete } from "@mui/material";
import {Button} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

import { Modal, Radio } from 'antd';
import NumberFormat from "react-number-format";

import './Loans.css'

const ApplicantFinancials = ({ addTxnLine, isModalOpen, setIsModalOpen, txnLines }) => {
    const { pageSize } = useContext(UserContext);
    const validDataRef = useRef(false);

    const [cashFlowCategory, setCashFlowCategory] = useState();

    const [frequency, setFrequency] = useState("MONTHLY");
    const [amount, setAmount] = useState();
    const [subTotal, setSubTotal] = useState();
    const [amountError, setAmountError]=useState(false)

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { data: cashFlowCategories } = useQuery({
        queryKey: ['cashFlowCategories'],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/cashflow-categories?page_size=${pageSize}`);
          return response.data.results;
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        validDataRef.current=true  
        
        const expenseAmount = cashFlowCategory.category === "EXPENSE" ? amount : 0
        const incomeAmount = cashFlowCategory.category === "INCOME" ? amount : 0

        const newTxnLine = {
            id: cashFlowCategory.id,
            name:cashFlowCategory.name,
            category:cashFlowCategory.id,
            amount:amount,
            frequency:frequency,
            expenseAmount:expenseAmount, // Used for table display
            incomeAmount:incomeAmount, // Used for table display
        };

        addTxnLine(newTxnLine);
        setIsModalOpen(false);
    };

    return (
        <>
        <div className="product-details-container application-guarantor-container">
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Name</th>
                        <th>Income</th>
                        <th>Expense</th>
                        <th></th>
                    </tr>
                </thead>
                {txnLines && txnLines.map((txnLine, index) => (
                    <tbody key={index}>
                        <tr>
                            <td>{txnLine.id}</td>
                            <td>{txnLine.name}</td>
                            <td>{txnLine.incomeAmount?Number(txnLine.incomeAmount).toLocaleString():""}</td>
                            <td>{txnLine.expenseAmount?Number(txnLine.expenseAmount).toLocaleString():""}</td>
                            <td>
                                <IconButton 
                                    size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>

        <div className="AddRow">
            <Button
                id="AddRowButton"
                onClick={() => {
                    setIsModalOpen(true)}
                }
                variant="outlined" 
                size="small"
                startIcon={<AddCircleOutlineIcon />}
            >
                Income/Expense
            </Button>
        </div>
        {isModalOpen && 
            <Modal className="dashboard-modal" title="Add Income/Expense" visible={isModalOpen} open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <div className="dashboard-form">
                    <form onSubmit={handleSubmit}>
                        <Radio.Group 
                            value={frequency}
                            className="custom-input"
                        >
                            <Radio value="MONTHLY">Monthly</Radio>
                            <Radio disabled value="ANNUALLY">Annual</Radio>
                        </Radio.Group>

                        <Autocomplete
                            onChange={(event, newValue) => {
                                setCashFlowCategory(newValue);
                            }}
                            options={cashFlowCategories}
                            getOptionLabel={(option) => option? option.name: ""}
                            renderInput={(params) => 
                                <TextField 
                                    className='custom-input'
                                    label="Category" 
                                    {...params} 
                                />
                            }
                        />
                        <TextField className="custom-input"
                            value={cashFlowCategory?cashFlowCategory.category_name:""}
                            label="Type"
                            variant="outlined" 
                            fullWidth
                            disabled
                        /> 

                        <NumberFormat 
                            // value={amt.current>0?amt.current:""}
                            onChange={(e) => {
                                const amt = parseFloat(e.target.value.replace(/,/g, ''))
                                if (amt>0){
                                    setAmountError(false)
                                    setAmount(amt)
                                }
                                else{
                                    setAmountError(true)
                                }
                            }} 
                            className="custom-input"
                            fullWidth
                            label="Amount" 
                            variant="outlined" 
                            customInput={TextField}
                            thousandSeparator={true} 
                            required
                        />

                    </form>
                </div>
            </Modal>
        }
        </>

    );
};

export default ApplicantFinancials;
